import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService/backendService';

interface UseGeoLocationResult {
  country: string | null;
  isLoading: boolean;
  error: string | null;
  isUS: boolean;
}

const GEOLOCATION_QUERY_KEY = ['geolocation'] as const;

/**
 * Custom hook to fetch the user's geolocation based on their IP address
 * Uses the backend /v0.5/geoip endpoint to determine the user's country
 */
export const useGeoLocation = (): UseGeoLocationResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: GEOLOCATION_QUERY_KEY,
    queryFn: async () => {
      const data = await BackendService.instance.geoip.getLocation();
      return data;
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    gcTime: 1000 * 60 * 60 * 24, // 24 hours (formerly cacheTime in v4)
  });

  const country = data?.country ?? null;

  return {
    country,
    isLoading,
    error: error ? 'Failed to determine location' : null,
    isUS: country === 'US',
  };
};

export default useGeoLocation;
